module.exports = __webpack_public_path__ + "static/media/icon_baldio.30217a77.svg";